import { CaseTableViewInstanceState } from 'app/area/case-report/case-table-view/types-store';
import { ApplicationState } from 'app/types-store';

export const selectCaseTableViewInstanceState = (caseTableViewInstanceKey: string) =>
  (state: ApplicationState): CaseTableViewInstanceState =>
    state?.caseTableView?.instances?.[caseTableViewInstanceKey];

export const selectCaseTableViewTotalResutlsState = (caseTableViewInstanceKey: string) =>
  (state: ApplicationState): number =>
    state?.caseTableView?.instances?.[caseTableViewInstanceKey]?.caseTableViewResults?.metadata.totalNumberOfResults;

export const selectCaseTableViewExternalUrlTemplateState = (caseTableViewInstanceKey: string) =>
  (state: ApplicationState): string =>
    state?.caseTableView?.instances?.[caseTableViewInstanceKey]?.singleSupplierUrl;
